import { Box, Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { PhoneIcon, WhatsAppIcon } from "src/assets";
import ProgressBarTitle from "src/components/Displays/ProgressBarTitle";
import PrimaryButton from "src/components/Shared/PrimaryButton";
import { Link as LinkMui } from "@mui/material";

const WhatsAppBox = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  const title = t("hotlineContact.contactBox.title");
  const point1 = t("hotlineContact.contactBox.point1");
  const point2 = t("hotlineContact.contactBox.point2");

  return (
    <Stack
      gap={4}
      sx={{
        border: `1px solid ${theme.palette.grey[100]}`,
        borderRadius: "16px",
        padding: 3,
        backgroundColor: theme.palette.background.paper,
      }}
    >
      <Typography
        sx={{
          fontSize: "22px",
          fontWeight: "normal",
          color: theme.palette.grey[500],
        }}
      >
        {title}
      </Typography>

      <Stack gap={1}>
        <LinkMui
          href="tel:+494063602422"
          sx={{
            width: "fit-content",
            cursor: "pointer",
            textDecoration: "underline !important",
            color: theme.palette.grey[500],
            "&:hover": {
              textDecoration: "underline",
            },
          }}
        >
          <Stack direction="row" gap={2} alignItems="center">
            <PhoneIcon
              style={{
                width: 20,
                height: 20,
                color: theme.palette.grey[500],
              }}
            />
            <ProgressBarTitle text={point1} color={theme.palette.grey[500]} />
          </Stack>
        </LinkMui>

        <Stack direction="row" gap={2} alignItems="flex-start">
          <Box sx={{ width: 20, height: 20 }} />
          <ProgressBarTitle text={point2} color={theme.palette.grey[500]} />
        </Stack>
      </Stack>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          mt: 2,
          mb: 2,
          width: "99%",
          alignItems: "center",
        }}
      >
        <LinkMui
          href="https://wa.me/494063601563"
          target="_blank"
          rel="noopener noreferrer"
          underline="none"
          sx={{ width: "100%", textDecoration: "none" }}
        >
          <PrimaryButton
            text={
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  color: theme.palette.text.primary,
                  paddingRight: 0,
                }}
              >
                <Box sx={{ textAlign: "left", flexGrow: 1, paddingLeft: 7 }}>
                  WhatsApp öffnen
                </Box>

                <Box
                  sx={{
                    height: 35,
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "auto",
                    paddingRight: 0,
                  }}
                >
                  <WhatsAppIcon
                    style={{
                      width: 35,
                      height: 35,
                      color: theme.palette.grey[500],
                      marginRight: 5,
                    }}
                  />
                </Box>
              </Box>
            }
            sx={{
              backgroundColor: "#fff",
              border: "1px solid black",
              width: "100%",
              textTransform: "none",
              paddingY: 1.2,
              paddingX: 0,
              "&:hover": {
                backgroundColor: theme.palette.action.hover,
                border: "1px solid black",
              },
            }}
          />
        </LinkMui>
      </Box>
    </Stack>
  );
};

export default WhatsAppBox;
